import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ICU from 'i18next-icu';
import { resources, defaultNS } from './config';
import getUserLocale from './utils/getUserLocale';
import { FALLBACK_LANGUAGE } from '../config/constants';

// eslint-disable-next-line import/no-named-as-default-member
i18n
  .use(initReactI18next)
  .use(ICU)
  .init({
    resources,
    lng: await getUserLocale(),
    returnEmptyString: false,
    fallbackLng: FALLBACK_LANGUAGE,
    defaultNS,
    ns: [defaultNS],
  });
